import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IndexationType } from "../../../../../../Wrap/Models/Models/Processes/Quote/Pension/IndexationType";

export const PensionBenefitsSteppersMap = {
    pensionBenefitsDetails: "Pension benefits details",
    incomePaymentDetails: "Income payment details",
    review: "Review",
    comfirm: "Confirmation",
};

export const productMap = {
    [SubAccountType.Sipp]: "SIPP",
    [SubAccountType.StocksIsa]: "ISA Stocks & Shares",
    [SubAccountType.PersonalPortfolio]: "Personal Portfolio",
    [SubAccountType.WrapCash]: "Wrap Cash",
};

export const IndexationMap = {
    [IndexationType.AverageWeeklyEarning]: "Average weekly earning",
    [IndexationType.FixedPercentage]: "User defined percentage",
};

export const FinancialAdviceMap = {
    true: "Yes",
    false: "No",
};

export enum PensionBenefitsActionType {
    Add = "add",
    Edit = "edit",
}

export const DocumentsAndDeclarationContent = {
    declarations: {
        investmentPathway: "I can confirm that the client has been presented with all relevant investment pathway information as this is not a personal recommendation",
    },
};
